module.exports = __webpack_public_path__ + "static/media/bob-scaled.c5afe304.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bob-scaled.jpg
// module id = 186
// module chunks = 0